<template>
  <div class="cbp_tmicon" :class="stateobj.classe ? stateobj.classe : 'bg-secondary'">
    <span class="text-white"><i class="fa " aria-hidden="true" :class="stateobj.icon ? stateobj.icon : 'Non disponible'"></i></span>
  </div>
</template>

<script>
import { statusOrder } from '@/modules/order/plugins/status';

export default {
  name: 'MessageError',
  props:{
      state: Number,
      icon: Boolean
  },
  computed:{
    stateobj(){
      return statusOrder.find(status => status.value === parseInt(this.state))
    }
  },
  data(){
      return {
        statusOrder: statusOrder
      }
  },
  methods: {
    
  },
}
</script>

<style>
</style>
  